"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var parse_response_1 = require("./parse-response");
var SoFetch = /** @class */ (function () {
    function SoFetch(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.requestInterceptors, requestInterceptors = _c === void 0 ? [] : _c, _d = _b.responseInterceptors, responseInterceptors = _d === void 0 ? [] : _d, _e = _b.rootUrl, rootUrl = _e === void 0 ? function () { return ''; } : _e;
        this.requestInterceptors = requestInterceptors;
        this.responseInterceptors = responseInterceptors;
        this.rootUrl = rootUrl;
    }
    SoFetch.prototype.applyRequestInterceptors = function (options) {
        return this.requestInterceptors.reduce(function (opts, interceptor) {
            return interceptor(options);
        }, __assign({}, options));
    };
    SoFetch.prototype.applyResponseInterceptors = function (response, config) {
        // chuck the config onto the response so we can get at it later
        response.config = config;
        return this.responseInterceptors.reduce(function (newResp, interceptor) {
            return interceptor(newResp);
        }, response);
    };
    SoFetch.prototype.fetch = function (url, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        var fullUrl = this.rootUrl() + url;
        var headers = new Headers(options.headers || {});
        var finalOpts = this.applyRequestInterceptors(__assign({ method: 'GET' }, options, { headers: headers, url: fullUrl }));
        return fetch(fullUrl, finalOpts)
            .then(function (resp) { return parse_response_1.default(resp); })
            .then(function (resp) { return _this.applyResponseInterceptors(resp, finalOpts); })
            .then(function (resp) {
            if (resp.isError) {
                throw resp;
            }
            else {
                return resp;
            }
        });
    };
    SoFetch.prototype.post = function (url, postBody, options) {
        var headers = new Headers((options && options.headers) || {});
        headers.set('Content-Type', 'application/json');
        return this.fetch(url, __assign({ method: 'POST' }, options, { headers: headers, body: postBody ? JSON.stringify(postBody) : undefined }));
    };
    SoFetch.prototype.put = function (url, postBody, options) {
        var headers = new Headers((options && options.headers) || {});
        headers.set('Content-Type', 'application/json');
        return this.fetch(url, __assign({}, options, { method: 'PUT', body: JSON.stringify(postBody), headers: headers }));
    };
    return SoFetch;
}());
exports.default = SoFetch;
//# sourceMappingURL=so-fetch.js.map